export default __webpack_public_path__ + "static/media/Stocks.2644aa0e.svg";